"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Load App's css (scss)
require("~/assets/css/index.scss");
// Import bootstrap js
require("bootstrap/dist/js/bootstrap.bundle.min");
// prismjs
const Prism = require("prismjs/components/prism-core");
require("prismjs/components/prism-bash");
require("prismjs/components/prism-clike");
require("prismjs/components/prism-javascript");
require("prismjs/components/prism-markup");
require("prismjs/components/prism-css");
require("prismjs/components/prism-json");
Prism.highlightAll();
require("prismjs/themes/prism.css");
